import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { cn } from "@/lib/utils";

export default function AccordionWrapper({
  content,
  trigger,
  hideChevron,
  triggerClasses,
  orientation,
  noRotate,
  asChild = false,
  chevronPosition = "start",
  onValueChange,
  value,
  preventAll,
}: {
  content: React.ReactNode;
  trigger: React.ReactNode;
  hideChevron?: boolean;
  triggerClasses?: string;
  orientation?: "vertical" | "horizontal";
  noRotate?: boolean;
  asChild?: boolean;
  chevronPosition?: "start" | "end";
  onValueChange?: (value: string) => void;
  value?: string;
  preventAll?: boolean;
}) {
  const itemValue = value || "item-1";
  return (
    <Accordion
      type="single"
      collapsible
      orientation={orientation}
      value={value}
      onValueChange={onValueChange}
    >
      <AccordionItem value={itemValue} className="border-none">
        <AccordionTrigger
          onClick={(e) => {
            preventAll && e.stopPropagation();
            preventAll && e.preventDefault();
          }}
          asChild={asChild}
          noRotate={noRotate}
          hideChevron={hideChevron}
          chevronPosition={chevronPosition}
          className={cn("flex justify-end", triggerClasses)}
        >
          {asChild ? <div>{trigger}</div> : trigger}
        </AccordionTrigger>
        <AccordionContent className="">{content}</AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
